/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import "./SignIn.css";
import { useEffect, useState } from "react";
import { CircularProgress } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";
import axios from "axios";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import MainLayout from "layouts/authentication/components/MainLayout";
import bgImage from "assets/images/login_Image.png";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useMaterialUIController, setDarkMode } from "context";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import IconButton from "@mui/material/IconButton";
import { encryptObject } from "utils/encrypt";
import logoImg from "assets/images/DTC.png";
import ReCAPTCHA from "react-google-recaptcha";
import { useRef } from "react";




function SignIn() {
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const [controller, dispatch] = useMaterialUIController();
  const recaptchaRef = useRef(null);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [isFormInvalid, setIsFormInvalid] = useState(false);
  const [passvisible, setPassvisible] = useState(false);

  const [captchaToken, setCaptchaToken] = useState(null);
  const USERNAME_MAX = 50;
  const PASSWORD_MAX = 50;

  const emailLimitShown = useRef(false);
  const passwordLimitShown = useRef(false);

  const [errors, setErrors] = useState({
    email: "",
    password: "",
  });
  const isSubmitDisabled =
    loading ||
    !captchaToken ||
    !!errors.email ||
    !!errors.password;



  useEffect(() => {
    localStorage.clear();
    setCaptchaToken(null);
    setDarkMode(dispatch, false);
  }, []);

  const resetCaptcha = () => {
    setCaptchaToken(null);
    recaptchaRef.current?.reset();
  };


  const onSignIn = async () => {
    if (!email || !password) {
      return enqueueSnackbar("Please fill all the details.", {
        variant: "error",
      });
    }
    if (email.length > USERNAME_MAX || password.length > PASSWORD_MAX) {
      return enqueueSnackbar("Input exceeds allowed character limit.", {
        variant: "error",
      });
    }

    if (!captchaToken) {
      return enqueueSnackbar("Please verify captcha.", {
        variant: "error",
      });
    }

    setLoading(true);

    const payload = {
      username: encryptObject(email),
      password: encryptObject(password),
      captchaToken,
    };

    axios({
      method: "post",
      url:
        process.env.REACT_APP_BASEURL +
        "user-service-and-maintenance/login",
      data: payload,
      withCredentials: true,
    })
      .then((response) => {
        const { success, message, data } = response.data;

        if (success) {
          if (data.role === "User") {
            setLoading(false);
            return enqueueSnackbar(
              "You are not authorized to log in here.",
              { variant: "error" }
            );
          }


          const userData = {
            role: data.role,
            username: data.username,
            login_status: "true",
            userID: data._id,
            serviceID: data.serviceID,
          };

          const encryptedUserData = encryptObject(userData);

          document.cookie = `userData=${encodeURIComponent(
            JSON.stringify(encryptedUserData)
          )}; path=/; max-age=${60 * 60 * 24}; SameSite=Strict`;

          setLoading(false);
          navigate("/dashboard");

          enqueueSnackbar(
            `${data.role} Login Successful.`,
            { variant: "success" }
          );

          window.location.reload();
        } else {
          setLoading(false);
          setIsFormInvalid(true);
          resetCaptcha();

          if (
            message &&
            message.toLowerCase().includes("already logged")
          ) {
            return enqueueSnackbar(
              "You are already logged in on another device or session. Please log out from the other session and try again.",
              { variant: "warning" }
            );
          }

          return enqueueSnackbar(message, { variant: "error" });
        }
      })
      .catch((error) => {
        setLoading(false);
        setIsFormInvalid(true);
        resetCaptcha();

        const errorMessage =
          error?.response?.data?.message ||
          "Login failed. Please try again.";

        enqueueSnackbar(errorMessage, { variant: "error" });
      });
  };
  const handleEmailChange = (e) => {
    const value = e.target.value;

    if (value.length >= USERNAME_MAX) {
      setEmail(value.slice(0, USERNAME_MAX));
      setErrors((prev) => ({
        ...prev,
        email: `Maximum ${USERNAME_MAX} characters allowed`,
      }));

      if (!emailLimitShown.current) {
        enqueueSnackbar(
          `Username can have maximum ${USERNAME_MAX} characters.`,
          { variant: "error" }
        );
        emailLimitShown.current = true;
      }

      return;
    }

    emailLimitShown.current = false;
    setEmail(value);
    setErrors((prev) => ({ ...prev, email: "" }));
    setIsFormInvalid(false);
  };

  const handlePasswordChange = (e) => {
    const value = e.target.value;

    if (value.length >= PASSWORD_MAX) {
      setPassword(value.slice(0, PASSWORD_MAX));
      setErrors((prev) => ({
        ...prev,
        password: `Maximum ${PASSWORD_MAX} characters allowed`,
      }));

      if (!passwordLimitShown.current) {
        enqueueSnackbar(
          `Password can have maximum ${PASSWORD_MAX} characters.`,
          { variant: "error" }
        );
        passwordLimitShown.current = true;
      }

      return;
    }

    passwordLimitShown.current = false;
    setPassword(value);
    setErrors((prev) => ({ ...prev, password: "" }));
    setIsFormInvalid(false);
  };

  return (
    <MainLayout image={bgImage}>
      <Grid>
        <MDBox
          maxWidth="304px"
          width="100%"
          mx="auto"
        >
          <MDBox
            display="flex"
            justifyContent="center"
            mb={4}
          >
            <MDBox
              component="img"
              src={logoImg}
              alt="DTC"
              width="60%"
            />
          </MDBox>


          {/* Headings */}
          <MDBox textAlign="left" mb={3}>
            <Typography component="h1" variant="h5" className="allhead">
              Welcome Back
            </Typography>
            <Typography
              variant="body2"
              sx={{
                fontSize: "14px",
                fontWeight: 500,
                color: "rgba(0, 0, 0, 0.75)",
              }}
            >
              Enter your username and password to continue
            </Typography>
          </MDBox>

          {/* Form */}
          <MDBox
            component="form"
            role="form"
            onKeyDown={(e) => {
              if (e.key === "Enter" && !isSubmitDisabled) {
                e.preventDefault();
                onSignIn();
              }

            }}
          >
            {/* Username */}
            <MDBox mb={2}>
              <MDInput
                type="email"
                label="Username"
                fullWidth
                value={email}
                error={!!errors.email}
                // helperText={errors.email}
                inputProps={{ maxLength: USERNAME_MAX }}
                onChange={handleEmailChange}
              />

            </MDBox>

            {/* Password */}
            <MDBox mb={2}>
              <MDInput
                type={passvisible ? "text" : "password"}
                label="Password"
                fullWidth
                value={password}
                error={!!errors.password}
                // helperText={errors.password}
                inputProps={{ maxLength: PASSWORD_MAX }}
                onChange={handlePasswordChange}
                InputProps={{
                  endAdornment: password && (
                    <IconButton onClick={() => setPassvisible(!passvisible)} edge="end">
                      {passvisible ? <VisibilityOffIcon /> : <VisibilityIcon />}
                    </IconButton>
                  ),
                }}
              />

            </MDBox>

            {/*  CAPTCHA */}
            <MDBox mb={3}>
              <ReCAPTCHA
                ref={recaptchaRef}
                sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                onChange={(token) => setCaptchaToken(token)}
              />
            </MDBox>

            <MDButton
              variant="gradient"
              fullWidth
              onClick={onSignIn}
              disabled={isSubmitDisabled}
              style={{
                backgroundColor: "#f00000",
                color: "rgba(255, 255, 255, 1)",
              }}
            >
              {loading ? (
                <CircularProgress size={20} sx={{ color: "inherit" }} />
              ) : (
                "Login"
              )}
            </MDButton>
          </MDBox>
        </MDBox>
      </Grid>
    </MainLayout>
  );

}

export default SignIn;
